import script from "./OutageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OutageList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__